import request from '@/utils/request';

/**
 * 查询作品列表
 */
export function listProjects(params) {
  return request({
    url: '/front/project/list',
    method: 'get',
    params
  });
}

/**
 * 查询作品详情
 */
export function getProject(id) {
  return request({
    url: `/front/project/${id}`,
    method: 'get'
  });
}

/**
 * 新增作品
 */
export function createProject(data) {
  return request({
    url: '/front/project',
    method: 'post',
    data
  });
}

/**
 * 编辑作品基本信息（含封面）
 */
export function updateProject(id, data) {
  return request({
    url: `/front/project/${id}`,
    method: 'put',
    data
  });
}

/**
 * 删除作品
 */
export function deleteProject(id) {
  return request({
    url: `/front/project/${id}`,
    method: 'delete'
  });
}

/**
 * 上传封面图片
 */
export function uploadCover(formData) {
  return request({
    url: '/common/upload',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  });
}
